<template>
  <div class="wrapper">
    <AuthRoleManagement
      ref="role"
      :currentRole.sync="currentRole"
      class="wrap-role"
    ></AuthRoleManagement>

    <div class="wrap-other">
      <main class="wrap-menu-button">
        <AuthMenuTree
          :currentRole="currentRole"
          @update:currentMenuCode="currentMenuCode = arguments[0]"
          ref="menu"
          class="wrap-menu"
        ></AuthMenuTree>
        <AuthButtonList
          ref="button"
          class="wrap-button"
          :currentRole="currentRole"
          :currentMenuCode="currentMenuCode"
          :changeRecords="changeRecords"
          @add-record="addRecord"
          @remove-record="removeRecord"
        ></AuthButtonList>
      </main>
      <footer class="tc">
        <el-button :loading="loading" type="primary" @click="saveAuth">保存</el-button>
      </footer>
    </div>
  </div>
</template>

<script>
import {system} from '../../api'
import AuthRoleManagement from './AuthRoleManagement'
import AuthMenuTree from './AuthMenuTree'
import AuthButtonList from './AuthButtonList'

export default {
  name: 'AuthManagement',

  components: {
    AuthRoleManagement,
    AuthMenuTree,
    AuthButtonList
  },

  mounted () {
    this.$refs.role.getRoleList()
  },

  data () {
    return {
      loading: false,
      // 当前菜单
      currentMenuCode: '',
      // 当前角色
      currentRole: '',
      changeRecords: {
        unchecked: [],
        checked: []
      }
    }
  },

  watch: {
    currentRole (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetForm()
        this.currentMenuCode = ''
      }
    }
  },

  methods: {
    resetForm () {
      this.changeRecords = {
        unchecked: [],
        checked: []
      }
    },
    addRecord (type, buttonId) {
      this.changeRecords[type].push(buttonId)
      this.$refs.menu.setMenuChecked(this.currentMenuCode, true)
    },
    removeRecord (type, index) {
      this.changeRecords[type].splice(index, 1)
    },
    async saveAuth () {
      let checkedMenuIds = this.$refs.menu.getCheckedKeysFromTree()
      if (!checkedMenuIds.length) {
        this.$message({
          type: 'error',
          message: '未选择菜单'
        })
        return
      }
      this.loading = true
      let {code, msg} = await system.saveAuthOfMenuAndButton({
        button: this.changeRecords,
        roleId: this.currentRole,
        menu: checkedMenuIds
      })
      this.loading = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '权限配置成功'
        })
        this.resetForm()
      } else {
        this.$message({
          type: 'error',
          message: msg || '权限配置失败'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
%wrapper {
  display: flex;
  & > :first-child {
    width: 280px;
    flex-shrink: 0;
  }
  & > :last-child {
    flex-grow: 1;
  }
}
.wrapper, .wrap-menu-button {
  @extend %wrapper;
  .wrap-role {
    margin-right: 10px;
  }
}
%box {
  display: flex;
  flex-flow: column nowrap;
  background-color: white;
  border-radius: 4px;

  /deep/ main {
    flex-grow: 1;
    padding: 0 20px;
  }
  /deep/ footer {
    flex-shrink: 0;
    height: 70px;
    padding: 0 20px;
    line-height: 70px;
    border-top: 1px solid #eee;
  }
}
.wrap-other, .wrap-role {
  @extend %box;
}
.wrap-other main {
  padding: 0;
}
.wrap-menu-button {
  .wrap-menu {
    border-right: 1px solid #eee;
    padding: 0 20px;
  }
  .wrap-button {
    padding: 0 20px;
  }
}
.wrapper /deep/ .card-title {
  height: 60px;
  line-height: 60px;
}
.wrap-button /deep/ .el-form {
  width: auto;
}
</style>
